import { useList, useSelect, useTable } from '@pankod/refine-core'
import { IBloomLevel, ICompetency, IDifficultyLevel, IGrade, IQuestionStatus, IReportTheme, IStrand, ISubject, ITNTaxonomy } from 'interfaces'

export const useQuestionStatus = (enabled: any) => {
  console.log({ enabled })
  return useList<IQuestionStatus>({
    queryOptions: { enabled: enabled },
    resource: 'question_statuses',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
    },
  })
}
export const useGrades = (enabled: any) => {
  // console.log({enabled});
  return useSelect<IGrade>({
    queryOptions: { enabled: enabled },
    resource: 'grades',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
}
export const useBloomsLevel = (enabled: any) => {
  console.log({ enabled })

  return useSelect<IBloomLevel>({
    queryOptions: { enabled: enabled },
    resource: 'blooms_levels',
    optionLabel: 'name',
    fetchSize: 100,
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'order', order: 'asc' }],
  })
}
export const useDifficultyLevels = (enabled: any) => {
  return useSelect<IDifficultyLevel>({
    queryOptions: { enabled: enabled },
    resource: 'difficulty_levels',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'order', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
}
export const useSubjects = (enabled: any, searchValue?: string) => {
  return useSelect<ISubject>({
    queryOptions: { enabled: enabled },
    resource: 'subjects',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => {
      const search = searchValue ?? value.toLowerCase()
      return [
        {
          field: 'name',
          operator: 'contains',
          value: `${search}%`,
        },
      ]
    },
  })
}
export const useProjectsConfig = (enabled: any) => {
  return useSelect({
    queryOptions: { enabled: enabled },
    resource: 'project_config',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'report_theme_ids'],
    },
    sort: [{ field: 'created_at', order: 'desc' }],
  })
}

export const useCompetency = (enabled: any) => {
  return useSelect<ICompetency>({
    queryOptions: { enabled: enabled },
    resource: 'competencies',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 10000,
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
}
export const useStandard = (enabled: any) => {
  return useSelect<IStrand>({
    queryOptions: { enabled: enabled },
    resource: 'strands',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 10000,
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
}
export const useReportTheme = (enabled: any, filterOption: any) => {
  return useSelect<IReportTheme>({
    queryOptions: { enabled: enabled },
    resource: 'report_themes',
    // defaultValueQueryOptions:{},
    fetchSize: 10000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: filterOption,
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
}

export const useTableDifficultyLevel = (enabled: any) => {
  const { tableQueryResult: difficultyResult } = useTable<IDifficultyLevel>({
    resource: 'difficulty_levels',
    initialPageSize: 100,
    metaData: { fields: ['id', 'name'] },
    queryOptions: { enabled: enabled },
  })
  return difficultyResult
}
export const useTableBloomsLevel = (enabled: any) => {
  const { tableQueryResult: bloomsResult } = useTable<IBloomLevel>({
    resource: 'blooms_levels',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name'] },
    queryOptions: { enabled: enabled },
  })
  return bloomsResult
}
export const useTableCompetencies = (enabled: any) => {
  const { tableQueryResult: competenciesResult } = useTable<ICompetency>({
    resource: 'competencies',
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name'] },
    queryOptions: { enabled: enabled },
  })
  return competenciesResult
}
export const useTableStrands = (enabled: any) => {
  const { tableQueryResult: strandsResult } = useTable<IStrand>({
    resource: 'strands',
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name'] },
    queryOptions: { enabled: enabled },
  })
  return strandsResult
}
export const useTestTracks = (enabled: any) => {
  const { tableQueryResult: strandsResult } = useTable<IStrand>({
    resource: 'test_tracks',
    initialPageSize: 100000,
    metaData: { fields: ['id', 'name'] },
    queryOptions: { enabled: enabled },
  })
  return strandsResult
}
